import React from 'react';
import { MessageSquare, LayoutDashboard, HelpCircle, GraduationCap, ExternalLink } from 'lucide-react';
import SidebarMenuItem from './SidebarMenuItem';

/**
 * 전용 메뉴 목록과 아토스 외부 링크를 포함하는 네비게이션 컴포넌트.
 */
const SidebarNav = ({ activeTab, setActiveTab, isOpen }) => {
    return (
        <nav className="space-y-1">
            <SidebarMenuItem
                icon={<MessageSquare size={20} />}
                label="채팅 메인"
                isActive={activeTab === 'chat'}
                onClick={() => setActiveTab('chat')}
                isOpen={isOpen}
            />
            <SidebarMenuItem
                icon={<LayoutDashboard size={20} />}
                label="질의 현황 관리"
                isActive={activeTab === 'history'}
                onClick={() => setActiveTab('history')}
                isOpen={isOpen}
            />
            <SidebarMenuItem
                icon={<HelpCircle size={20} />}
                label="자주 묻는 질문 (FAQ)"
                isActive={activeTab === 'faq'}
                onClick={() => setActiveTab('faq')}
                isOpen={isOpen}
            />

            <div className={`my-3 border-t border-gray-200/60 ${isOpen ? 'mx-2' : 'w-6 mx-auto'}`} />

            {isOpen ? (
                <a
                    href="https://edu.atos.co.kr/main"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full flex items-center justify-between px-4 py-3 rounded-xl text-base font-bold text-gray-600 hover:bg-white hover:shadow-sm transition-all group"
                >
                    <div className="flex items-center gap-3">
                        <GraduationCap size={20} className="text-gray-500 group-hover:text-blue-600" />
                        <span className="text-gray-700">아토스 안전 보건교육</span>
                    </div>
                    <ExternalLink size={14} className="text-gray-400 group-hover:text-blue-500" />
                </a>
            ) : (
                <div className="flex justify-center">
                    <a
                        href="https://edu.atos.co.kr/main"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="아토스 안전 보건교육"
                        className="w-2 h-2 flex items-center justify-center rounded-xl text-gray-500 hover:bg-white hover:text-blue-600 hover:shadow-sm transition-all"
                    >
                        <GraduationCap size={20} />
                    </a>
                </div>
            )}
        </nav>
    );
};

export default SidebarNav;
